import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface NewsState {
  searchTerm: string;
}

const initialState: NewsState = {
  searchTerm: '',
};

const newsSlice = createSlice({
  name: 'news',
  initialState,
  reducers: {
    setSearchTerm(state, action: PayloadAction<string>) {
      state.searchTerm = action.payload.trim();
    },
  },
});

export const { setSearchTerm } = newsSlice.actions;

export default newsSlice.reducer;
